// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg width=%27100%25%27 height=%27100%25%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3crect width=%27100%25%27 height=%27100%25%27 fill=%27none%27 rx=%27100%27 ry=%27100%27 stroke=%27%232A2A2AFF%27 stroke-width=%273%27 stroke-dasharray=%2712%27 stroke-dashoffset=%2786%27 stroke-linecap=%27butt%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-review-container {
  padding: 80px 0;
}
.request-review-container .save {
  height: 100px;
  width: 100px;
  position: fixed;
  right: 20%;
  bottom: 100px;
  font-weight: 700;
  border-radius: 100%;
  z-index: 5;
  box-shadow: 0px 6px 10px 2px rgba(0, 0, 0, 0.15);
  background-color: var(--primary-color-1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  border-radius: 100px;
  transition: 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  visibility: visible;
}
.request-review-container .save > p {
  transition: 0.3s ease-in-out;
  text-align: center;
  margin: 0;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.request-review-container .save > p > svg {
  position: absolute;
  top: -133px;
}
.request-review-container .save:disabled {
  background-color: var(--secondary-color-2);
  background-image: none;
  opacity: 0;
  visibility: hidden;
}
.request-review-container .save:disabled:hover {
  transform: none;
}
.request-review-container .save:disabled:hover > p {
  transform: none;
}
.request-review-container .save:hover {
  transform: rotate(30deg);
}
.request-review-container .save:hover > p {
  transform: rotate(-30deg);
}
.request-review-container .header {
  flex-direction: column;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  gap: 8px;
}
.request-review-container .header > p {
  margin: 0;
}
.request-review-container .header .back-button {
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  color: #2a2a2a;
  position: absolute;
  left: 0;
  transition: 0.2s ease-in-out;
}
.request-review-container .header .back-button:hover {
  color: var(--primary-color-1);
}
.request-review-container .contents-container {
  display: flex;
  justify-content: center;
}
.request-review-container .contents-container #showing-preview.contents {
  position: absolute;
  box-shadow: none;
  width: 480px !important;
  top: -100%;
  z-index: 1;
}
.request-review-container .contents-container .contents {
  width: 400px;
  display: flex;
  flex-direction: column;
  z-index: 2;
}
.request-review-container .contents-container .contents .preview {
  width: 400px;
  height: 200px;
  border-radius: 24px;
  object-fit: cover;
}
.request-review-container .contents-container .contents .content-details {
  width: 100%;
}
.request-review-container .contents-container .contents .content-details .listing-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.request-review-container .contents-container .contents .content-details .listing-details .address, .request-review-container .contents-container .contents .content-details .listing-details .listing, .request-review-container .contents-container .contents .content-details .listing-details .title {
  font-family: "Proxima Nova", sans-serif;
  margin: 0;
}
.request-review-container .contents-container .contents .content-details .listing-details .address {
  font-size: 14px;
  color: #949494;
}
.request-review-container .contents-container .contents .content-details .listing-details .title {
  font-size: 20px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.request-review-container .contents-container .contents .content-details .listing-details .listing {
  font-size: 14px;
  color: #949494;
}
.request-review-container .contents-container .contents .content-details .user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  align-items: center;
}
.request-review-container .contents-container .contents .content-details .info-container {
  display: flex;
  border-radius: 24px;
  background: #F9F9F9;
  padding: 24px;
}
.request-review-container .contents-container .contents .content-details .info-container .details {
  font-family: "Proxima Nova", sans-serif;
}
.request-review-container .contents-container .contents .content-details .info-container .details .showing {
  flex-direction: column;
  gap: 8px;
  display: flex;
}
.request-review-container .contents-container .contents .content-details .info-container .details .showing .date {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: var(--secondary-color-1);
}
.request-review-container .contents-container .contents .content-details .info-container .details .showing .address, .request-review-container .contents-container .contents .content-details .info-container .details .showing .specific {
  font-weight: 400;
  margin: 0;
  font-size: 14px;
  color: #949494;
}
.request-review-container .contents-container .contents .content-details .agent {
  font-family: "Proxima Nova", sans-serif;
  font-size: 21px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 5px;
  color: var(--secondary-color-1);
}
.request-review-container .contents-container .contents .content-details .buyer-agent-info {
  display: flex;
  flex-wrap: wrap;
}
.request-review-container .contents-container .contents .content-details .buyer-agent-info > div {
  flex: 50% 1;
  display: flex;
  align-items: center;
  margin-bottom: 35px;
  font-size: 16px;
  font-weight: 600;
  color: var(--secondary-color-5);
  font-family: "Proxima Nova", sans-serif;
}
.request-review-container .contents-container .contents .content-details .buyer-agent-info > div > svg {
  margin-right: 15px;
}
.request-review-container .contents-container .contents .content-details .compensation {
  display: flex;
  align-items: center;
}
.request-review-container .contents-container .contents .content-details .compensation > span {
  color: var(--primary-color-1);
  font-weight: 700;
}
.request-review-container .contents-container .contents .add {
  font-weight: 700 !important;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.request-review-container .contents-container .contents .change {
  font-weight: 700 !important;
  display: flex;
  align-items: center;
  padding: 0 10px;
  background: white;
  color: var(--secondary-color-5);
  border: 1px solid var(--secondary-color-5);
}
.request-review-container .contents-container .contents .change:hover {
  opacity: 0.75;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .request-review-container .contents {
    flex-direction: column;
    padding: 0 20px;
  }
  .request-review-container .contents .preview {
    width: 100%;
    height: 420px;
  }
  .request-review-container .contents .content-details {
    width: 100%;
  }
  .request-review-container .contents .content-details .address {
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }
  .request-review-container .contents .content-details .listing {
    font-size: 16px;
    color: var(--secondary-color-2);
  }
  .request-review-container .contents .content-details .info-container .details, .request-review-container .contents .content-details .info-container .time {
    display: flex;
    flex-direction: column;
  }
  .request-review-container .contents .content-details .info-container .details .buyer {
    font-size: 18px;
  }
  .request-review-container .contents .content-details .info-container .details .showing .date {
    font-size: 14px;
  }
  .request-review-container .contents .content-details .info-container .details .showing .address {
    font-size: 10px;
  }
  .request-review-container .contents .content-details .info-container .time .duration {
    font-size: 14px;
  }
  .request-review-container .contents .content-details .info-container .time .specific {
    font-size: 10px;
  }
  .request-review-container .contents .content-details .agent {
    font-size: 18px;
  }
  .request-review-container .contents .content-details .company {
    font-size: 14px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .request-review-container .contents {
    flex-direction: column;
    padding: 0 20px;
  }
  .request-review-container .contents .preview {
    width: 100%;
    height: 420px;
  }
  .request-review-container .contents .content-details {
    width: 100%;
  }
  .request-review-container .contents .content-details .address {
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }
  .request-review-container .contents .content-details .listing {
    font-size: 16px;
    color: var(--secondary-color-2);
  }
  .request-review-container .contents .content-details .info-container .details, .request-review-container .contents .content-details .info-container .time {
    display: flex;
    flex-direction: column;
  }
  .request-review-container .contents .content-details .info-container .details .buyer {
    font-size: 18px;
  }
  .request-review-container .contents .content-details .info-container .details .showing .date {
    font-size: 14px;
  }
  .request-review-container .contents .content-details .info-container .details .showing .address {
    font-size: 10px;
  }
  .request-review-container .contents .content-details .info-container .time .duration {
    font-size: 14px;
  }
  .request-review-container .contents .content-details .info-container .time .specific {
    font-size: 10px;
  }
  .request-review-container .contents .content-details .agent {
    font-size: 18px;
  }
  .request-review-container .contents .content-details .company {
    font-size: 14px;
  }
}
@media (width: 1024px) and (max-height: 833px) {
  .request-review-container .contents {
    flex-direction: column;
    padding: 0 20px;
  }
  .request-review-container .contents .preview {
    width: 100%;
    height: 420px;
  }
  .request-review-container .contents .content-details {
    width: 100%;
  }
  .request-review-container .contents .content-details .address {
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }
  .request-review-container .contents .content-details .listing {
    font-size: 16px;
    color: var(--secondary-color-2);
  }
  .request-review-container .contents .content-details .info-container .details, .request-review-container .contents .content-details .info-container .time {
    display: flex;
    flex-direction: column;
  }
  .request-review-container .contents .content-details .info-container .details .buyer {
    font-size: 18px;
  }
  .request-review-container .contents .content-details .info-container .details .showing .date {
    font-size: 14px;
  }
  .request-review-container .contents .content-details .info-container .details .showing .address {
    font-size: 10px;
  }
  .request-review-container .contents .content-details .info-container .time .duration {
    font-size: 14px;
  }
  .request-review-container .contents .content-details .info-container .time .specific {
    font-size: 10px;
  }
  .request-review-container .contents .content-details .agent {
    font-size: 18px;
  }
  .request-review-container .contents .content-details .company {
    font-size: 14px;
  }
}
@media (width: 1024px) and (max-height: 833px) {
  .request-review-container .contents {
    flex-direction: column;
    padding: 0 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/RequestReview/requestReview.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;AAEI;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,gDAAA;EACA,wCAAA;EACA,oEAAA;EACA,oBAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AAAR;AACQ;EACI,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACZ;AAAY;EACI,kBAAA;EACA,WAAA;AAEhB;AACQ;EACI,0CAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AACZ;AAAY;EACI,eAAA;AAEhB;AADgB;EAAM,eAAA;AAItB;AADQ;EACI,wBAAA;AAGZ;AAFY;EACI,yBAAA;AAIhB;AAAI;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAER;AADQ;EACI,SAAA;AAGZ;AADQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,4BAAA;AAGZ;AAFY;EACI,6BAAA;AAIhB;AAAI;EACI,aAAA;EACA,uBAAA;AAER;AAAY;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;AAEhB;AACQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AACZ;AAAY;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAEhB;AAAY;EACI,WAAA;AAEhB;AADgB;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAGpB;AAFoB;EACI,uCAAA;EACA,SAAA;AAIxB;AAFoB;EACI,eAAA;EACA,cAAA;AAIxB;AAFoB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAIxB;AAFoB;EACI,eAAA;EACA,cAAA;AAIxB;AADgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAGpB;AADgB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAGpB;AAFoB;EACI,uCAAA;AAIxB;AAHwB;EACI,sBAAA;EACA,QAAA;EACA,aAAA;AAK5B;AAJ4B;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;AAMhC;AAJ4B;EACI,gBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAMhC;AAAgB;EACI,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,+BAAA;AAEpB;AAAgB;EACI,aAAA;EACA,eAAA;AAEpB;AADoB;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;AAGxB;AAFwB;EACI,kBAAA;AAI5B;AAAgB;EACI,aAAA;EACA,mBAAA;AAEpB;AADoB;EACI,6BAAA;EACA,gBAAA;AAGxB;AACY;EACI,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAChB;AACY;EACI,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,0CAAA;AAChB;AAAgB;EACI,aAAA;AAEpB;;AC9MY;EDqNJ;IACI,sBAAA;IACA,eAAA;EAHV;EAIU;IACI,WAAA;IACA,aAAA;EAFd;EAIU;IACI,WAAA;EAFd;EAGc;IACI,eAAA;IACA,cAAA;IACA,kBAAA;EADlB;EAGc;IACI,eAAA;IACA,+BAAA;EADlB;EAIkB;IACI,aAAA;IACA,sBAAA;EAFtB;EAKsB;IACI,eAAA;EAH1B;EAM0B;IACI,eAAA;EAJ9B;EAM0B;IACI,eAAA;EAJ9B;EASsB;IACI,eAAA;EAP1B;EASsB;IACI,eAAA;EAP1B;EAWc;IACI,eAAA;EATlB;EAWc;IACI,eAAA;EATlB;AACF;ACvPY;ED8MJ;IACI,sBAAA;IACA,eAAA;EA4CV;EA3CU;IACI,WAAA;IACA,aAAA;EA6Cd;EA3CU;IACI,WAAA;EA6Cd;EA5Cc;IACI,eAAA;IACA,cAAA;IACA,kBAAA;EA8ClB;EA5Cc;IACI,eAAA;IACA,+BAAA;EA8ClB;EA3CkB;IACI,aAAA;IACA,sBAAA;EA6CtB;EA1CsB;IACI,eAAA;EA4C1B;EAzC0B;IACI,eAAA;EA2C9B;EAzC0B;IACI,eAAA;EA2C9B;EAtCsB;IACI,eAAA;EAwC1B;EAtCsB;IACI,eAAA;EAwC1B;EApCc;IACI,eAAA;EAsClB;EApCc;IACI,eAAA;EAsClB;AACF;AC/RY;EDuMJ;IACI,sBAAA;IACA,eAAA;EA2FV;EA1FU;IACI,WAAA;IACA,aAAA;EA4Fd;EA1FU;IACI,WAAA;EA4Fd;EA3Fc;IACI,eAAA;IACA,cAAA;IACA,kBAAA;EA6FlB;EA3Fc;IACI,eAAA;IACA,+BAAA;EA6FlB;EA1FkB;IACI,aAAA;IACA,sBAAA;EA4FtB;EAzFsB;IACI,eAAA;EA2F1B;EAxF0B;IACI,eAAA;EA0F9B;EAxF0B;IACI,eAAA;EA0F9B;EArFsB;IACI,eAAA;EAuF1B;EArFsB;IACI,eAAA;EAuF1B;EAnFc;IACI,eAAA;EAqFlB;EAnFc;IACI,eAAA;EAqFlB;AACF;AC9UY;EDiQJ;IACI,sBAAA;IACA,eAAA;EAgFV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.request-review-container {\r\n    padding: 80px 0;\r\n    .save {\r\n        height: 100px;\r\n        width: 100px;\r\n        position: fixed;\r\n        right: 20%;\r\n        bottom: 100px;\r\n        font-weight: 700;\r\n        border-radius: 100%;\r\n        z-index: 5;\r\n        box-shadow: 0px 6px 10px 2px rgba(0, 0, 0, 0.15);\r\n        background-color: var(--primary-color-1);\r\n        background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%232A2A2AFF' stroke-width='3' stroke-dasharray='12' stroke-dashoffset='86' stroke-linecap='butt'/%3e%3c/svg%3e\") !important;\r\n        border-radius: 100px;\r\n        transition: .3s ease-in-out;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        opacity: 1;\r\n        visibility: visible;\r\n        > p { \r\n            transition: .3s ease-in-out;\r\n            text-align: center;\r\n            margin: 0;\r\n            height: 100%;\r\n            width: 100%;\r\n            position: relative;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            > svg {\r\n                position: absolute;\r\n                top: -133px;\r\n            }\r\n        }\r\n        &:disabled {\r\n            background-color: var(--secondary-color-2);\r\n            background-image: none;\r\n            opacity: 0;\r\n            visibility: hidden;\r\n            &:hover {\r\n                transform: none;\r\n                > p { transform: none; }\r\n            }\r\n        }\r\n        &:hover {\r\n            transform: rotate(30deg);\r\n            > p {\r\n                transform: rotate(-30deg);\r\n            }\r\n        }\r\n    }\r\n    .header {\r\n        flex-direction: column;\r\n        display: flex;\r\n        align-items: center;\r\n        position: relative;\r\n        width: 100%;\r\n        gap: 8px;\r\n        > p {\r\n            margin: 0;\r\n        }\r\n        .back-button {\r\n            cursor: pointer;\r\n            font-size: 16px;\r\n            font-weight: 700;\r\n            color: #2a2a2a;\r\n            position: absolute;\r\n            left: 0;\r\n            transition: .2s ease-in-out;\r\n            &:hover {\r\n                color: var(--primary-color-1);\r\n            }\r\n        }\r\n    }\r\n    .contents-container {\r\n        display: flex;\r\n        justify-content: center;\r\n        #showing-preview {\r\n            &.contents {\r\n                position: absolute;\r\n                box-shadow: none;\r\n                width: 480px !important;\r\n                top: -100%;\r\n                z-index: 1;\r\n            }\r\n        }\r\n        .contents {\r\n            width: 400px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            z-index: 2;\r\n            .preview {\r\n                width: 400px;\r\n                height: 200px;\r\n                border-radius: 24px;\r\n                object-fit: cover;\r\n            }\r\n            .content-details {\r\n                width: 100%;\r\n                .listing-details {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    gap: 8px;\r\n                    .address, .listing, .title {\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        margin: 0;\r\n                    }\r\n                    .address {\r\n                        font-size: 14px;\r\n                        color: #949494;\r\n                    }\r\n                    .title {\r\n                        font-size: 20px;\r\n                        font-weight: 700;\r\n                        color: var(--secondary-color-1);\r\n                    }\r\n                    .listing {\r\n                        font-size: 14px;\r\n                        color: #949494;\r\n                    }\r\n                }\r\n                .user-info {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    gap: 8px;\r\n                    align-items: center;\r\n                }\r\n                .info-container {\r\n                    display: flex;\r\n                    border-radius: 24px;\r\n                    background: #F9F9F9;\r\n                    padding: 24px;\r\n                    .details {\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        .showing {\r\n                            flex-direction: column;\r\n                            gap: 8px;\r\n                            display: flex;\r\n                            .date {\r\n                                font-size: 20px;\r\n                                font-weight: 700;\r\n                                margin: 0;\r\n                                color: var(--secondary-color-1);\r\n                            }\r\n                            .address, .specific  {\r\n                                font-weight: 400;\r\n                                margin: 0;\r\n                                font-size: 14px;\r\n                                color: #949494;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .agent {\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n                    font-size: 21px;\r\n                    font-weight: 700;\r\n                    margin: 0;\r\n                    margin-bottom: 5px;\r\n                    color: var(--secondary-color-1);\r\n                }\r\n                .buyer-agent-info {\r\n                    display: flex;\r\n                    flex-wrap: wrap;\r\n                    > div {\r\n                        flex: 50%;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        margin-bottom: 35px;\r\n                        font-size: 16px;\r\n                        font-weight: 600;\r\n                        color: var(--secondary-color-5);\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        > svg {\r\n                            margin-right: 15px;\r\n                        }\r\n                    }\r\n                }\r\n                .compensation {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    > span {\r\n                        color: var(--primary-color-1);\r\n                        font-weight: 700;\r\n                    }\r\n                }\r\n            }\r\n            .add {\r\n                font-weight: 700 !important;\r\n                display: flex;\r\n                align-items: center;\r\n                padding: 0 10px;\r\n            }\r\n            .change {\r\n                font-weight: 700 !important;\r\n                display: flex;\r\n                align-items: center;\r\n                padding: 0 10px;\r\n                background: white;\r\n                color: var(--secondary-color-5);\r\n                border: 1px solid var(--secondary-color-5);\r\n                &:hover {\r\n                    opacity: .75;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile, tablet, nitty-gritt) {\r\n    .request-review-container {\r\n        .contents {\r\n            flex-direction: column;\r\n            padding: 0 20px;\r\n            .preview {\r\n                width: 100%;\r\n                height: 420px;\r\n            }\r\n            .content-details {\r\n                width: 100%;\r\n                .address {\r\n                    font-size: 24px;\r\n                    margin: 20px 0;\r\n                    text-align: center;\r\n                }\r\n                .listing {\r\n                    font-size: 16px;\r\n                    color: var(--secondary-color-2);\r\n                }\r\n                .info-container {\r\n                    .details, .time {\r\n                        display: flex;\r\n                        flex-direction: column;\r\n                    }\r\n                    .details {\r\n                        .buyer {\r\n                            font-size: 18px;\r\n                        }\r\n                        .showing {\r\n                            .date {\r\n                                font-size: 14px;\r\n                            }\r\n                            .address {\r\n                                font-size: 10px;\r\n                            }\r\n                        }\r\n                    }\r\n                    .time {\r\n                        .duration {\r\n                            font-size: 14px;\r\n                        }\r\n                        .specific {\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                }\r\n                .agent {\r\n                    font-size: 18px;\r\n                }\r\n                .company {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(nitty-gritt) {\r\n    .request-review-container {\r\n        .contents {\r\n            flex-direction: column;\r\n            padding: 0 40px;\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
